module.exports = __webpack_public_path__ + "76a70cca5c3770c0324e57bd8e79dadd.fbx";